// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Components
import DatePicker from "vue2-datepicker"
const FileUpload = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/_shared/_components/file-upload/file-upload.vue"
	)
const BreedTableComponent = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "breed-table-component"*/ "@/app/views/main-view/_shared/_components/breed-table-component/breed-table-component.vue"
	)
const ModalFindReplaceWithPetName = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-find-replace-with-pet-name"*/ "@/app/views/main-view/notifications/containers/modals/modal-find-replace-with-pet-name/modal-find-replace-with-pet-name.vue"
	)

// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { productMixins } from "@/app/mixins/modules/product-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"

// Services
import ProductService from "@/app/services/main/product/product-service"
import BreedService from "@/app/services/main/breeds/breeds-service"
import SuppliersService from "@/app/services/main/suppliers/suppliers-service"

// Constants
import { STATUS_CODES } from "@/app/constants/constants"

export default {
	name: "ProductAddEditComponent",
	components: {
		DatePicker,
		FileUpload,
		BreedTableComponent,
		ModalFindReplaceWithPetName,
	},
	mixins: [productMixins, toastMessageMixins, numberFormatMixins, inputTextMixins, dateMixins],
	data() {
		return {
			// container
			productEditDetails: null,
			// fields
			productId: "",
			productName: "",
			productDescription: "",
			price: "0.00",
			salePrice: "0.00",
			onSale: false,
			monthlyPrice: "0.00",
			quarterlyPrice: "0.00",
			yearlyPrice: "0.00",
			isProductTypeLoading: false,
			isBrandsLoading: false,
			applicableBreeds: [],
			breedList: [],
			hasBreedListChanges: false,
			nameDuplicateWarning: false,
			isAddEditProduct: true,
			checkNameLoading: false,
			selectedProductType: "",
			selectTypeIsBreed: false,
			selectTypeIsStoreCredit: false,
			breederId: "",
			breederName: "",
			breederMobile: "",
			mobileNumberIsValid: true,
			breedId: "",
			birthDate: "",
			gender: "",
			colour: "",
			size: "",
			weight: "",
			supplierList: [],
			selectedSupplier: "",
			externalSKU: "",
			stockQuantity: 0,
			minStockQuantity: 5,
			cost: "0.00",
			costIncomeTax: "0.00",
			isBreedsAPILoading: false,
			genderList: [
				{ name: "Male", value: "M" },
				{ name: "Female", value: "F" },
			],
			sizeList: [
				{
					id: 1,
					name: "Toy",
				},
				{
					id: 2,
					name: "Small",
				},
				{
					id: 3,
					name: "Medium",
				},
				{
					id: 4,
					name: "Large",
				},
				{
					id: 5,
					name: "Extra Large",
				},
			],

			// Images
			primaryImage: "",
			images: [],
			imageRef: [],
			fileBlob: null,
			filesToSend: [],
			setAsPrimary: 0,
			updatedImages: [],
			deletedImages: [],
			copiedImages: [],
			imgCtr: 0,
			isDuplicate: false,
			isNewForm: false,
			isPriceChange: false,

			imageTypeList: ['image/svg','image/png','image/jpg','image/jpeg','image/gif','image/raw', 'image/webp', 'image/avif'],
		}
	},
	computed: {
		validationRules() {
			let fields = {
				productName: {},
				selectedProductType: {},
			}

			fields = vuelidateUtil.setFieldsRequired(fields, true)

			if (this.onSale) {
				fields.salePrice = {}
				fields = vuelidateUtil.setFieldsRequired(fields, true)
			}

			// Check if Subscription
			fields.price = {}
			if (this.subscriptionFlag) {
				fields.price = {}
				fields.salePrice = {}
			} else {
				fields = vuelidateUtil.setRequiredValidation(fields, "price")
				fields = vuelidateUtil.setMinValueValidation(fields, "price", 0)
				if (this.onSale) {
					fields = vuelidateUtil.setRequiredValidation(fields, "salePrice")
					fields = vuelidateUtil.setMinValueValidation(fields, "salePrice", 1)
				}
			}

			return fields
		},
		compareFields() {
			let initialBrandId = null
			let initialProductId = null
			let comparePrice
			let compareAge = false
			let compareSize = false
			let compareFrequency = false
			let compareQuarterlyPrice = false
			let compareYearlyPrice = false

			const {
				name,
				productType: { id: productId },
				brand: { id: brandId },
				price,
				quarterlyPrice,
				yearlyPrice,
				subscriptionBundle,
				age,
				frequencyPeriodCode,
				breedSize: { id: breedSizeId },
				description,
				salePrice,
				onSale,
				productInventory,
			} = this.productEditDetails

			// check if has any selected brand
			if (this.selectedBrand) {
				initialBrandId = this.selectedBrand.id
			}

			// check if has any selected product type
			if (this.selectedProductType) {
				initialProductId = this.selectedProductType.id
			}

			if (subscriptionBundle) {
				comparePrice = price !== this.monthlyPrice
				compareQuarterlyPrice = quarterlyPrice !== this.quarterlyPrice
				compareYearlyPrice = yearlyPrice !== this.yearlyPrice
			} else {
				comparePrice = price !== this.price
			}

			if (this.isNotTrackingOrEmpty) {
				compareAge = (age ? age : "") !== this.selectedAge
				compareSize = (breedSizeId ? breedSizeId : "") !== this.selectedSize

				if (this.isTreatmentOrEmpty) {
					compareFrequency = (frequencyPeriodCode ? frequencyPeriodCode : "") !== this.selectedFrequency
				}
			}

			// compare
			const compareName = name !== this.productName
			const compareType = productId !== initialProductId
			const compareBrand = brandId !== initialBrandId
			const compareSubscriptionFlag = subscriptionBundle !== this.subscriptionFlag
			const compareDescription = (description ? description : "") !== this.productDescription
			const compareDeletedImages = this.deletedImages.length > 0
			const compareUpdatedImages = this.updatedImages.length > 0
			const compareFilesToSend = this.filesToSend.length > 0
			const compareSalePrice =
				salePrice !== this.salePrice && this.onSale && parseFloat(this.salePrice) < parseFloat(this.price)
			const compareOnSale = this.onSale != onSale
			const compareStockQuantity =
				this.stockQuantity != (productInventory.stockQty ? productInventory.stockQty : "")
			const compareMinStockQty =
				this.minStockQuantity != (productInventory.minStock ? productInventory.minStock : "")
			const compareCost = this.cost != (productInventory.cost ? productInventory.cost : "0.00")
			const compareCostIncomeTax =
				this.costIncomeTax != (productInventory.costIncTax ? productInventory.costIncTax : "0.00")
			const compareSupplier =
				this.selectedSupplier != (productInventory.supplierId ? productInventory.supplierId : "")
			this.isPriceChange = comparePrice || compareSalePrice || compareQuarterlyPrice || compareYearlyPrice

			return !(
				compareName ||
				compareType ||
				compareBrand ||
				this.hasBreedListChanges ||
				comparePrice ||
				compareQuarterlyPrice ||
				compareAge ||
				this.isImageChanged ||
				compareSize ||
				compareSubscriptionFlag ||
				compareYearlyPrice ||
				compareFrequency ||
				compareDescription ||
				compareDeletedImages ||
				compareUpdatedImages ||
				compareFilesToSend ||
				compareSalePrice ||
				compareOnSale ||
				compareStockQuantity ||
				compareMinStockQty ||
				compareCost ||
				compareCostIncomeTax ||
				compareSupplier
			)
		},
		compareOtherProductFields() {
			const {
				name,
				price,
				birthDate,
				breederId,
				breederName,
				breedId,
				gender,
				colour,
				size,
				breederMobile,
				description,
			} = this.productEditDetails

			// compare
			const compareName = name !== this.productName
			const compareDescription = description !== this.productDescription
			const compareColour = colour !== this.colour
			const comparePrice = price !== this.price
			const compareSize = size.name !== this.size.name
			const compareBreederId = breederId !== this.breederId
			const compareBreederName = breederName !== this.breederName
			const compareBreederMobile = breederMobile !== this.breederMobile
			const compareGender = gender !== this.gender
			const compareBreedId = breedId.id !== this.breedId.id
			const compareBday = !this.isSameDay(new Date(birthDate), new Date(this.birthDate))

			return !(
				compareName ||
				comparePrice ||
				this.isImageChanged ||
				compareSize ||
				compareColour ||
				compareBreederId ||
				compareBreederName ||
				compareGender ||
				compareBreedId ||
				compareBday ||
				compareBreederMobile ||
				compareDescription
			)
		},
		compareStoreCreditFields() {
			const { name, price } = this.productEditDetails

			// compare
			const compareName = name !== this.productName
			const comparePrice = price !== this.price

			return !(compareName || comparePrice || this.isImageChanged)
		},
		isNotTrackingOrEmpty() {
			let flag = false

			if (this.selectedProductType) {
				if (this.selectedProductType.name !== "Tracking") {
					flag = true
				}
			}

			return flag
		},
		isTreatmentOrEmpty() {
			let flag = false

			if (this.selectedProductType) {
				if (this.selectedProductType.name === "Treatment") {
					flag = true
				}
			}

			return flag
		},
		isBreedOrEmpty() {
			let flag = false

			if (this.selectedProductType) {
				if (this.selectedProductType.name !== "Breed") {
					flag = true
					this.selectTypeIsBreed = false
				} else {
					this.selectTypeIsBreed = true
				}
			}

			return flag
		},
		isInvalid() {
			if (this.productEditDetails) {
				// edit if no changes then set the button to disabled
				if (this.selectTypeIsBreed) {
					return this.isValid() || this.compareOtherProductFields
				} else if (this.selectTypeIsStoreCredit) {
					return this.isValidStoreCredit() || this.compareStoreCreditFields
				} else {
					return this.compareFields || this.$v.$invalid || this.isEditAPILoading
				}
			} else if (this.selectTypeIsBreed) {
				return this.isValid()
			} else if (this.selectTypeIsStoreCredit) {
				return this.isValidStoreCredit()
			} else {
				// add if no changes then set the button to disabled
				return this.$v.$invalid || this.isEditAPILoading
			}
		},
		isValidSalePrice() {
			return parseFloat(this.salePrice) >= parseFloat(this.price)
		},
	},
	created() {
		this.initialLoad()
		this.isDuplicate = this.$route.name === "Copy Product"
		this.isNewForm = this.$route.name === "Add Product" || this.$route.name === "Copy Product"
	},
	watch: {
		selectedProductType(newType) {
			if (!newType) {
				this.selectTypeIsBreed = false
				this.selectTypeIsStoreCredit = false
				this.selectedBrand = null
				return
			}

			// clear any data it has when product List is refreshed
			this.brandList = []

			if (!this.isEditMode) {
				this.selectedBrand = null
			}

			if (this.isAddEditProduct) {
				// this.$v.$reset();
			}

			if (newType.id === 7) {
				// this.$v.$reset();
				this.selectTypeIsBreed = false
				this.selectTypeIsStoreCredit = true
			} else if (newType.id === 6) {
				// this.$v.$reset();
				this.selectTypeIsBreed = true
				this.selectTypeIsStoreCredit = false
			} else {
				// this.$v.$reset();
				this.selectTypeIsBreed = false
				this.selectTypeIsStoreCredit = false
			}

			newType = newType.name ? newType.name : newType
			this.getBrandList(newType.toLowerCase())
			// set to false so it will clear when user changes productType on edit mode.
			this.isEditMode = false
		},
	},
	methods: {
		async initialLoad() {
			await this.getProductTypeList()
			await this.getBreedList()
			await this.getSuppliersList()
			await this.getSubscriptionPeriodList()
			await this.getProductTreatmentFrequencyList()
			this.setFieldsForUpdate()
		},

		async getBreedList() {
			this.isBreedsAPILoading = true
			const res = await BreedService.getBreeds()

			if (res.status === STATUS_CODES.SUCCESS) {
				this.breedList = res.data.data
			}

			this.isBreedsAPILoading = false
		},

		// Get Suppliers List for Dropdown
		async getSuppliersList() {
			const res = await SuppliersService.getSuppliersList()
			if (res.status === STATUS_CODES.SUCCESS) {
				this.supplierList = res.data
			}
		},

		notPastDate(date) {
			return date > new Date().setHours(0, 0, 0, 0)
		},

		setFieldsForUpdate() {
			if (this.$route.params && this.$route.params.id) {
				this.isEditAPILoading = true
				this.isEditMode = true
				ProductService.getProductById(this.$route.params.id).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const {
							age,
							breedSize,
							name,
							price,
							productType,
							brand,
							quarterlyPrice,
							yearlyPrice,
							imageUrl,
							frequencyPeriodCode,
							subscriptionBundle,
							breeds,
							description,
							images,
							onSale,
							salePrice,
							id,
							productInventory,
						} = res.data

						this.productId = id
						this.productEditDetails = res.data
						this.selectedProductType = productType
						this.price = price
						this.productName = name
						this.imageUrl = imageUrl
						this.subscriptionFlag = subscriptionBundle
						this.productDescription = description ? description : ""
						this.primaryImage = imageUrl
						this.images = images
						this.imgCtr = images.length
						this.copiedImages = images
						this.onSale = onSale
						this.salePrice = salePrice
						this.stockQuantity = productInventory.stockQty ? productInventory.stockQty : 0
						this.minStockQuantity = productInventory.minStock ? productInventory.minStock : 0
						this.cost = productInventory.cost ? productInventory.cost : "0.00"
						this.costIncomeTax = productInventory.costIncTax ? productInventory.costIncTax : "0.00"
						this.externalSKU = productInventory.externalSKU
						this.selectedSupplier = productInventory.supplierId ? productInventory.supplierId : null

						if (this.$route.name === "Copy Product") {
							this.callGetProductByNameAPI()
						}

						//Select the primary image
						images.forEach((img, i) => {
							if (img.primary) {
								this.setAsPrimary = i
							}
						})

						this.getOtherDetails(productType)
						// this.onBlur('productType');

						if (age) {
							this.selectedAge = age
							// this.onBlur('selectedAge');
						}

						if (frequencyPeriodCode) {
							this.selectedFrequency = frequencyPeriodCode
							// this.onBlur('selectedFrequency');
						}

						if (subscriptionBundle) {
							this.quarterlyPrice = quarterlyPrice
							this.yearlyPrice = yearlyPrice
							this.monthlyPrice = price
						}

						if (brand.id && brand.name) {
							this.selectedBrand = brand
							// this.onBlur('brand');
						} else {
							this.selectedBrand = null
						}

						setTimeout(() => {
							if (breedSize.id) {
								this.selectedSize = breedSize.id
								// this.onBlur('selectedSize');
							}

							if (breeds && breeds[0].breedId) {
								this.applicableBreeds = breeds.map(({ breedId, breedName, status }) => {
									return {
										id: breedId,
										name: breedName,
										status,
									}
								})
							}
						}, 500)
					} else {
						this.showAPIErrorToast(this.toastMessages.product().ERROR_PRODUCT_FETCH, res)
					}

					this.isEditAPILoading = false
				})
			}
		},

		getOtherDetails(productType) {
			if (productType.id === 6) {
				this.isEditAPILoading = false
				//getProductDogById
				ProductService.getProductDogById(this.$route.params.id).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { birthdate, breederId, breederName, colour, gender, size, breedId, breederMobile } =
							res.data

						//mobile number formatting
						let tempMobile = ""

						if (breederMobile) {
							tempMobile = breederMobile.split("")
							tempMobile.splice(4, 0, "-")
						}

						this.selectTypeIsBreed = true
						this.birthDate = new Date(birthdate)
						this.breederId = breederId
						this.breederName = breederName
						this.size = { name: size }
						this.gender = gender === "M" ? { name: "Male", value: "M" } : { name: "Female", value: "F" }
						this.colour = colour
						this.breedId = breedId
						this.breederMobile = tempMobile.join("")

						let breedData = this.breedList.filter((breed) => {
							return breed.id === this.breedId
						})

						this.breedId = breedData[0]

						this.productEditDetails = {
							...this.productEditDetails,
							birthDate: this.birthDate,
							breederId: this.breederId,
							breederName: this.breederName,
							breedId: this.breedId,
							gender: this.gender,
							colour: this.colour,
							size: this.size,
							breederMobile: this.breederMobile,
						}
					} else {
						this.showAPIErrorToast(this.toastMessages.product().ERROR_PRODUCT_FETCH, res)
					}
				})
			}
		},

		onSubmit(type, addMoreFlag = false) {
			if (this.isInvalid) {
				return
			}
			const apiType = type === "Edit Product" ? "edit" : "add"

			this.callProductAPI(apiType, addMoreFlag)
		},

		async callProductAPI(apiType, addMoreProduct) {
			let breeds = []

			// if (this.nameDuplicateWarning) {
			// 	this.showCustomErrorToast(null, `Product name is already used!`)
			// 	return
			// }

			for (let breed of this.breedList) {
				if (breed.status) {
					breeds.push({
						breedId: breed.id,
						status: breed.status,
					})
				}
			}

			let formDetails = {
				name: this.productName,
				price: parseFloat(this.price),
				productTypeId: this.selectedProductType.id,
				brandId: this.selectedBrand ? this.selectedBrand.id : null,
				subscriptionBundle: this.subscriptionFlag,
				isImageChanged: this.isImageChanged,
				description: this.productDescription,
				copyPhoto: this.imageUrl,
				imageRef: this.imageRef,
				onSale: this.onSale,
				salePrice: this.salePrice,
				supplierId: this.selectedSupplier ? this.selectedSupplier : null,
				stockQty: parseInt(this.stockQuantity),
				minStock: parseInt(this.minStockQuantity),
				cost: parseFloat(this.cost),
				costIncTax: parseFloat(this.costIncomeTax),
				externalSKU: this.externalSKU,
			}

			if (this.$route.name === "Copy Product") {
				formDetails.copyPhoto = this.imageUrl
			}

			if (this.isNotTrackingOrEmpty) {
				formDetails = {
					...formDetails,
					breedSizeId: this.selectedSize,
					age: this.selectedAge,
					breeds,
				}
			}

			if (this.isTreatmentOrEmpty) {
				formDetails = {
					...formDetails,
					frequencyPeriodCode: this.selectedFrequency,
				}
			}

			if (this.subscriptionFlag) {
				formDetails = {
					...formDetails,
					price: this.monthlyPrice,
					quarterlyPrice: this.quarterlyPrice,
					yearlyPrice: this.yearlyPrice,
				}
			}

			let productDetails = {
				formDetails,
				images: this.filesToSend.length ? this.filesToSend : [],
			}

			this.isEditAPILoading = true

			if (apiType === "add") {
				productDetails = {
					...productDetails,
					formDetails: {
						...formDetails,
						copiedImages: this.copiedImages.filter((dt) => dt.id),
					},
				}

				const res = await ProductService.postProducts(productDetails)
				const { SUCCESS_PRODUCT_ADD, ERROR_PRODUCT_ADD } = this.toastMessages.product()
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.resetFields()
					this.showCustomSuccessToast(SUCCESS_PRODUCT_ADD)

					if (!addMoreProduct) {
						this.$router.push("/products")
					} else {
						Object.assign(this.$data, this.$options.data.apply(this))
						this.initialLoad()
					}
				} else {
					this.showAPIErrorToast(ERROR_PRODUCT_ADD, res)
				}

				this.isEditAPILoading = false
			} else if (apiType === "edit") {
				productDetails = {
					...productDetails,
					formDetails: {
						...formDetails,
						updatedImages: this.updatedImages,
						deletedImages: this.deletedImages,
						isPriceChange: this.isPriceChange,
					},
				}

				try{
					const res = await ProductService.putProduct(this.$route.params.id, productDetails)
					const { SUCCESS_PRODUCT_EDIT, ERROR_PRODUCT_EDIT } = this.toastMessages.product()
	
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(SUCCESS_PRODUCT_EDIT)
						// redirect to product page after edit
						setTimeout(() => {
							this.$router.push("/products")
						}, 800)
					} else {
						this.showAPIErrorToast(ERROR_PRODUCT_EDIT, res)
					}
				} catch(err){
					this.showGenericErrorToast();
				} finally{
					this.isEditAPILoading = false;
				}

			}
		},

		nameKeyUp() {
			this.delayTyping(() => {
				if (this.productName !== "") {
					if (this.$route.name !== "Edit Product") {
						this.callGetProductByNameAPI()
					}
				}
			})
		},

		callGetProductByNameAPI() {
			const body = {
				f_name: this.productName,
			}
			this.checkNameLoading = true
			this.nameDuplicateWarning = false
			ProductService.getProductsByName(body).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					const products = res.data
					// check if there is already a product with the same name then ask for confirmation
					if (products.productCount > 0) {
						this.nameDuplicateWarning = true
					}
				} else {
					this.showAPIErrorToast("Unable to check product name.", res)
				}
				this.checkNameLoading = false
			})
		},

		resetCustomFields() {
			// container
			this.productEditDetails = null
			// fields
			this.productName = ""
			this.productDescription = ""
			this.selectedProductType = ""
			this.isProductTypeLoading = false
			this.selectedBrand = ""
			this.brandList = []
			this.isBrandsLoading = false
			this.price = "0.00"
			this.monthlyPrice = "0.00"
			this.quarterlyPrice = "0.00"
			this.yearlyPrice = "0.00"
			this.breedList = []
			this.applicableBreeds = []
		},

		handleBreedListUpdate(breedList) {
			this.breedList = breedList
		},

		handleBreedListChanges(hasChange) {
			this.hasBreedListChanges = hasChange
		},

		getAge(dateString) {
			let today = new Date()
			let birthDate = new Date(dateString)
			let age = today.getFullYear() - birthDate.getFullYear()
			let m = today.getMonth() - birthDate.getMonth()
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--
			}
			return age
		},

		resetBreedTypeFields() {
			this.productName = ""
			this.productDescription = ""
			this.birthDate = ""
			this.breedId = ""
			this.breederId = ""
			this.breederName = ""
			this.breederMobile = ""
			this.price = ""
			this.size = ""
			this.gender = ""
			this.colour = ""
			this.imageUrl = ""
			this.selectedProductType = ""

			// validation
			// this.$v.$reset();
		},

		isValid() {
			return !(
				this.productName != "" &&
				this.birthDate != "" &&
				this.breedId.id != "" &&
				this.breederId != "" &&
				this.breederName != "" &&
				this.price != "" &&
				this.size.name != "" &&
				this.gender != "" &&
				this.colour != "" &&
				this.imageUrl != "" &&
				this.selectedProductType != "" &&
				this.breederMobile != "" &&
				this.mobileNumberIsValid &&
				this.selectedProductType != null
			)
		},

		isValidStoreCredit() {
			return !(
				this.productName != "" &&
				this.price != "" &&
				this.imageUrl != "" &&
				this.selectedProductType != "" &&
				this.selectedProductType != null
			)
		},

		isSameDay(d1, d2) {
			return (
				d1.getFullYear() === d2.getFullYear() &&
				d1.getDate() === d2.getDate() &&
				d1.getMonth() === d2.getMonth()
			)
		},

		mobileNumberFormat(event) {
			//this.$v.breederMobile.$touch();
			this.mobileNumberIsValid = true

			let regexp = /^\d+$/

			let updateData = regexp.test(event.target.value.charAt(event.target.value.length - 1))

			if (updateData && event.target.value.length <= 11) {
				if (event.target.value.length === 5 && updateData) {
					let data = event.target.value.split("")
					if (event.target.value.charAt(4) === "-") {
						data.splice()
					} else {
						data.splice(4, 0, "-")
					}
					if (!updateData) {
						data.slice(0, -1)
					}
					data = data.join("")

					this.breederMobile = data
				} else {
					this.breederMobile = event.target.value
				}
			} else {
				this.breederMobile = event.target.value.slice(0, -1)
			}
		},

		checkFormat() {
			//this.$v.breederMobile.$touch();

			let regexp = /^\d{4}-\d{6}$/

			if (this.breederMobile !== null && this.breederMobile !== "") {
				this.mobileNumberIsValid = regexp.test(this.breederMobile)
			} else {
				this.mobileNumberIsValid = true
			}
		},

		replaceBodyWithPetName(newDescription) {
			this.productDescription = newDescription
		},

		insertName() {
			this.productDescription =
				this.productDescription === ""
					? this.productDescription + "PET_NAME"
					: this.productDescription + " PET_NAME "
		},

		showModalFindReplaceWithPetName() {
			this.$refs.modalFindReplaceWithPetName.show(this.productDescription)
		},

		// Image
		async onUploadImage(event) {
			// Change Object of images to Array
			const images = Object.values(event.target.files)

			// Validate Multiple Images as Array
			// let valid = this.validateMultipleImages(images)

			// compress image if more than 2mb
			const files = await this.compressMultipleImages(images)

			// do nothing when user cancels Upload
			// if (!valid) {
			// 	// reset uploader
			// 	this.$refs.uploader.value = ""
			// 	return
			// }

			this.fileBlob = files

			// Throw Error when uploaded images is more than 7
			if (images.length > 7 || this.images.length > 7 || this.images.length + images.length > 7) {
				this.showCustomErrorToast("Error", "Unable to upload more than 7 images.")
				return
			}

			// let primary = false
			// 		if (this.isNewForm && !this.isDuplicate) {
			// 			if (this.filesToSend.length === 0 && idx === 0) {
			// 				primary = true
			// 			}
			// 		} else {
			// 			if (this.imageSrc.length === 0 && idx === 0) {
			// 				primary = true
			// 			}
			// 		}

			const promises = [];

			for (let idx = 0; idx < this.fileBlob.length; idx++) {
				const file = this.fileBlob[idx];
				const valid = await this.validateImageWithType(file, this.imageTypeList);
		
				if (valid) {
					promises.push(new Promise((resolve) => {
						const reader = new FileReader();
						let primary = false;
		
						if (this.images.length === 0 && idx === 0) {
							primary = true;
						}
		
						reader.readAsDataURL(file);
		
						reader.onload = () => {
							if (this.images.length < 8) { // Allow 8 images total
								this.images.push(reader.result);
								this.filesToSend.push(file);
								this.imageRef.push({ primary, name: file.name });
							}
							resolve();
						};
					}));
				}
			}
		
			await Promise.all(promises);
		},

		removeImage(index, image) {
			this.images.splice(index, 1)
			let isPrimaryImageDeleted = false

			if (parseInt(this.setAsPrimary) < 0) {
				this.setAsPrimary = 0
			} else if (parseInt(this.setAsPrimary) > parseInt(index)) {
				this.setAsPrimary = this.setAsPrimary - 1
			} else if (parseInt(this.setAsPrimary) === parseInt(index)) {
				this.setAsPrimary = 0
				isPrimaryImageDeleted = true
			}

			const isNewImage = !image.id //Newly added image
			if (!isNewImage) {
				this.deletedImages.push(image)
				this.copiedImages = this.images.filter((dt) => dt.id)

				if (isPrimaryImageDeleted) {
					if (this.images.length === 0) {
						this.updatedImages = []
						return
					}
					this.updatedImages = []
					this.updatedImages.push({ ...this.images[0], primary: true })

					if (this.copiedImages.length > 0) {
						this.copiedImages[0].primary = true
					}
				}
			} else {
				const ctr = this.images.length - index

				this.imageRef.splice(ctr, 1)
				this.filesToSend.splice(ctr, 1)
			}
		},

		setPrimaryPhoto(index, image) {
			const isNewImage = !image.id //Newly added image
			if (isNewImage) {
				if (this.isNewForm && !this.isDuplicate) {
					//New form
					this.imageRef[this.setAsPrimary].primary = false
					this.imageRef[index].primary = true
					this.updatedImages = []
				} else if (this.isNewForm && this.isDuplicate) {
					const ctr = this.images.length - index
					const imageRefIdx = this.imageRef.length - ctr
					this.resetPrimaryPhoto("imageRef")
					this.imageRef[imageRefIdx].primary = true
					this.resetPrimaryPhoto("copiedImages")
				} else {
					//Update form
					const ctr = this.images.length - index
					const imageRefIdx = this.imageRef.length - ctr

					if(this.images[this.setAsPrimary].primary !== undefined){
						this.images[this.setAsPrimary].primary = false
					}


					if(this.imageRef[imageRefIdx].primary !== undefined){
						this.imageRef = [...this.imageRef].map(img => {
							return {...img, primary: false};
						})
						
						this.imageRef[imageRefIdx].primary = true
					}

					this.updatedImages = [this.images[this.setAsPrimary]]
				}
			} else {
				//Check if the form is a duplicate copy
				if (!this.isDuplicate) {
					if (this.updatedImages.length === 0) {
						//Reset all newly added images to primary false
						this.resetPrimaryPhoto("imageRef")

						//Insert the new primary photo to updatedImages
						this.updatedImages.push({ ...this.images[index], primary: true })
					} else {
						//Reset all newly added images to primary false
						this.resetPrimaryPhoto("imageRef")

						this.updatedImages = []
						//Insert the new primary photo to updatedImages
						this.updatedImages.push({ ...this.images[index], primary: true })
					}
				} else {
					this.resetPrimaryPhoto("imageRef")
					this.resetPrimaryPhoto("copiedImages")
					this.copiedImages[index].primary = true
				}
			}
		},

		//Reset primary photo of newly added images and previous images
		resetPrimaryPhoto(images) {
			if (this[images].length != 0) {
				this[images] = this[images].map((img) => {
					return {
						...img,
						primary: false,
					}
				})
			}
		},

		allowOnlyNumbers(e) {
			const invalidChars = ["-", "+", "e", "E"]
			if (invalidChars.includes(e.key)) {
				e.preventDefault()
			}
		},
	},
	// third party libraries
	validations() {
		return this.validationRules
	},
}
